import React, {useEffect, useState} from "react";
import Count from "../../common/count";
import {Link} from "react-router-dom";
import {getCMSAssets} from "../../../utils/cms.utils";

const ChooseUs = () => {
    const startYear = 2016
    const yearsExperience = Math.max(1, new Date().getFullYear() - startYear);

    const [assets, setAssets] = useState(null);

    useEffect(() => {
        setAssets(getCMSAssets());
    }, []);

    return (
        <section className="choose__us section-padding">
            <div className="container">
                <div className="row align-items-center">

                    {/* LEFT */}
                    <div className="col-xl-6">
                        <div className="choose__us-visual w-100 jc-center al-center text-center mx-auto">
                            <img src={assets?.why_choose_us} alt="Engineering Operations"/>

                            <div
                                className="choose__us-badge"
                            >
                                <strong>
                                    <Count number={yearsExperience}/>
                                    <span>+</span>
                                </strong>
                                <span>YEAR EXPERIENCE</span>
                                <span>Since {startYear}</span>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT */}
                    <div className="col-xl-6">
                        <div className="choose__us-content text-center">
                            <span className="subtitle text-center w-100">Why Choose Us</span>

                            <h2>
                                Reliable Engineering <br/>
                                &<br/>
                                Project Support Partner
                            </h2>

                            <p className="desc-en">
                                We deliver engineering and operational support
                                through disciplined execution, reliable assets,
                                and experienced professionals.
                            </p>

                            <p className="desc-id">
                                Kami menyediakan dukungan engineering dan
                                operasional melalui eksekusi yang disiplin,
                                aset yang andal, dan tenaga profesional
                                berpengalaman.
                            </p>

                            <ul className="choose__us-points">
                                <li>Asset & Fleet Readiness</li>
                                <li>Safety & Regulatory Compliance</li>
                                <li>Efficient Project Execution</li>
                            </ul>

                            <Link to="/contact-us" className="btn-corporate">
                                Discuss Your Project
                                <i className="flaticon-right-up"></i>
                            </Link>

                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default ChooseUs;
